module.exports = __webpack_public_path__ + "static/media/btn_secondaryschool_05_video.0ba7e464.png";